import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fields", "plantTypePb", "plantTypeField", "placementFields", "itemIdField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isPb = this.selectTarget.value === this.selectTarget.dataset.pbStockTypeId
    const isBr = this.selectTarget.value === this.selectTarget.dataset.brStockTypeId
    const itemIdInput = this.itemIdFieldTarget.querySelector("input")
    this.itemIdFieldTarget.hidden = !isBr
    itemIdInput.disabled = !isBr
    this.fieldsTarget.hidden = !isPb
    this.fieldsTarget.disabled = !isPb
    this.placementFieldsTarget.hidden = isPb
    this.placementFieldsTarget.disabled = isPb
    this.plantTypePbTarget.hidden = !isPb
    this.plantTypePbTarget.disabled = !isPb
    this.plantTypeFieldTarget.hidden = isPb
    this.plantTypeFieldTarget.disabled = isPb
  }
}
